import $ from "jquery";
import "slick-carousel";

const sliderReviews = () => {
  const el = {
    slider: ".mi-slider--reviews",
  };

  let $slider = $();

  const init = () => {
    $(function () {
      if (null !== document.querySelector(el.slider)) {
        $slider = $(el.slider);
        exec();

        $(window).on("resize", function () {
          $slider.trigger("setPosition");
        });
      }
    });
  };

  const initRules = (_idx, el) => {
    const $desc = $(el);
    const element = $desc.get(0);
    $desc.addClass("collapsed");

    if (element.scrollHeight > element.clientHeight) {
      const initialHeight = element.clientHeight;

      $desc.off("mouseenter").off("mouseleave");

      // let isAnimating = false;
      $desc
        .on("mouseenter", function (e) {
          // if (isAnimating) return;
          // isAnimating = true;

          $desc.animate(
            { height: element.scrollHeight + "px" },
            500,
            function () {
              $desc.toggleClass("collapsed").toggleClass("expanded");
              // isAnimating = false; // Reset flag in callback
            }
          );
        })
        .on("mouseleave", function (e) {
          // if (isAnimating) return;
          // isAnimating = true;

          $desc.animate({ height: initialHeight + "px" }, 500, function () {
            $desc.toggleClass("expanded").toggleClass("collapsed");
            // isAnimating = false; // Reset flag in callback
          });
        });
    }
  };

  const exec = () => {
    $slider
      .on("init", function (slick) {
        $(el.slider).find(`${el.slider}__desc`).each(initRules);
      })
      .slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        appendArrows: ".mi-slider--reviews__navigation",
        nextArrow:
          '<button class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m0 0-6 6m6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        prevArrow:
          '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M5 12l6 6m-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        responsive: [
          {
            breakpoint: 1181,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 897,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 601,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      })
      .on("setPosition", function (slick) {
        $(el.slider).find(`${el.slider}__desc`).each(initRules);
      });
  };

  init();
};

try {
  sliderReviews();
} catch (error) {
  console.error(error);
}
